import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
/* å¸å± */
import {FlexTopComponent} from './flex-tcb-module/flex-top/flex-top.component';
import {FlexBottomComponent} from './flex-tcb-module/flex-bottom/flex-bottom.component';
import {FlexBodyComponent} from './flex-tcb-module/flex-body/flex-body.component';
import {FlexLeftComponent} from './flex-lcr-module/flex-left/flex-left.component';
import {FlexRightComponent} from './flex-lcr-module/flex-right/flex-right.component';
import {FlexTopCenterBottomComponent} from './flex-tcb-module/flex-top-center-bottom/flex-top-center-bottom.component';
import {FlexLeftCenterRightComponent} from './flex-lcr-module/flex-left-center-right/flex-left-center-right.component';
import {LayoutVerticalCenterComponent} from './layout-vertical-center/layout-vertical-center.component';
import {ModuleTitleComponent} from './flex-tcb-module/module-title/module-title.component';
import {ModuleBottomComponent} from './flex-tcb-module/module-bottom/module-bottom.component';
import {NgZorroAntdModule} from 'ng-zorro-antd';


@NgModule({
    declarations: [
        /**/
        FlexTopComponent,
        FlexBottomComponent,
        FlexBodyComponent,
        FlexLeftComponent,
        FlexRightComponent,
        FlexTopCenterBottomComponent,
        FlexLeftCenterRightComponent,
        LayoutVerticalCenterComponent,
        ModuleTitleComponent,
        ModuleBottomComponent,


    ],
    imports: [
        CommonModule, NgZorroAntdModule
    ],
    exports: [
        FlexTopComponent,
        FlexBottomComponent,
        FlexBodyComponent,
        FlexLeftComponent,
        FlexRightComponent,
        FlexTopCenterBottomComponent,
        FlexLeftCenterRightComponent,
        LayoutVerticalCenterComponent,
        ModuleTitleComponent,
        ModuleBottomComponent,
    ]
})
export class LayoutsModule {
}
